import axios from 'axios';
import { DASHBOARD_API_URL } from '@/lib/constants/login';
import { camelify } from '@/helpers/case';

/* istanbul ignore next */
export function axiosInstanceCtor(ciToken = '') {
  return axios.create({
    baseURL: DASHBOARD_API_URL,
    headers: {
      'Authorization': `Token ${ciToken}`,
    },
  });
}

const tempData = [
  {
      "date": "2024-02-22",
      "regular": 1651.01,
      "voluntary": 0.0,
      "matched": 1651.0,
      "unmatched": 0.0,
      "total_contribution": 3302.01,
      "total_since_inception": 3302.01
  },
  {
      "date": "2024-02-23",
      "regular": 1651.01,
      "voluntary": 0.0,
      "matched": 1651.0,
      "unmatched": 0.0,
      "total_contribution": 3302.01,
      "total_since_inception": 6604.02
  }
];

// Create a Plan Sponsor Admin
export function employeeContributionsCtor(_) {
  const axiosInstance = _.axiosInstance;
  const _axios = axiosInstance;
  return async (id) => {
    /* istanbul ignore next */
    try {
      const result = await _axios.get(`/api/hradmin/employees/${id}/contributions_summary`);
      // if(result.data.length) {
      return result.data || [];
      // }
      // return tempData;
    } catch(e) {
      return Promise.reject(e);
    }
  };
}

export const employeeContributions = employeeContributionsCtor({ axiosInstance: null });